import { render, staticRenderFns } from "./message-text.vue?vue&type=template&id=1b01f03a&"
import script from "./message-text.vue?vue&type=script&lang=js&"
export * from "./message-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b01f03a')) {
      api.createRecord('1b01f03a', component.options)
    } else {
      api.reload('1b01f03a', component.options)
    }
    module.hot.accept("./message-text.vue?vue&type=template&id=1b01f03a&", function () {
      api.rerender('1b01f03a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/message-text.vue"
export default component.exports